import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/logo.png'


const _hoisted_1 = {
  class: "navbar navbar-expand-lg fixed-top",
  id: "navigation_bar"
}
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "#"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbar_menu",
  "aria-controls": "navbar_menu",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "navbar_menu"
}
const _hoisted_6 = { class: "navbar-nav ms-auto mb-2 mb-lg-0" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<li class=\"nav-item\"><a class=\"nav-link\" href=\"#about_us\">About</a></li><li class=\"nav-item\"><a class=\"nav-link\" href=\"#our_services\">Services</a></li><li class=\"nav-item\"><a class=\"nav-link\" href=\"#our_projects\">Projects</a></li><li class=\"nav-item\"><a class=\"nav-link\" href=\"https://myplusplus.com/policy.html\" target=\"_blank\">Policy</a></li><li class=\"nav-item action-btn\"><a class=\"nav-link border-btn\" href=\"#contact_us\">Let&#39;s Talk</a></li>", 5)

import { onMounted, onUnmounted, ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Navigation',
  setup(__props) {

const isDefaultLogo = ref(true);
let navbar: Element | null;
function handleScroll(e: Event) {
  if (window.scrollY > 50 && !navbar?.className.includes("navigation-bar-bg")) {
    navbar?.classList.add("navigation-bar-bg");
    navbar?.classList.add("shadow");
    isDefaultLogo.value = false;
  } else if (window.scrollY <= 50) {
    navbar?.classList.remove("navigation-bar-bg");
    navbar?.classList.remove("shadow");
    if (isDefaultLogo.value) {
      isDefaultLogo.value = true;
    }
  }
}

onMounted(() => {
  navbar = document.querySelector("#navigation_bar");
  console.log(navbar);

  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  window.addEventListener("scroll", handleScroll);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", _hoisted_6, [
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_router_link, {
              class: "nav-link active",
              "aria-current": "page",
              to: "/"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _hoisted_9
        ])
      ])
    ])
  ]))
}
}

})